import {
    nomeCurtoCliente,
    nomeCurtoConjuge,
} from '../String/nomeCurto'

const tipoSeguradoList = (values) => {
    let tipoSeguradoList = []

    let nomeCurtoClienteAux = nomeCurtoCliente(values)

    let nomeCurtoConjugeAux = nomeCurtoConjuge(values)

    if (nomeCurtoClienteAux) {
        tipoSeguradoList.push ({
            id: 'C',
            descricao: nomeCurtoClienteAux,
            ordem: 10,
        })
    }

    if (nomeCurtoConjugeAux) {
        tipoSeguradoList.push ({
            id: 'O',
            descricao: nomeCurtoConjugeAux,
            ordem: 20,
        })
    }

    return tipoSeguradoList
}

export default tipoSeguradoList